import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import ClickableListItem from 'LuxKit/List/ClickableListItem'
import useMerchandiseCategories from 'hooks/Merchandise/useMerchandiseCategories'
import MerchandiseMegaMenuPanel from './MerchandiseMegaMenuPanel'
import { getMerchandiseCategorySearchUrl } from '../../merchandiseUtils'
import { merchandiseMegaMenuBreakpoints } from './merchandiseMegaMenuBreakpoints'

const Container = styled(MerchandiseMegaMenuPanel)`
  display: flex;
  flex-direction: column;
  gap: ${rem(4)};
  padding: ${rem(24)};

  ${merchandiseMegaMenuBreakpoints.mediumLarge} {
    padding: ${rem(24)};
  }
`

const StyledClickableListItem = styled(ClickableListItem)`
  && {
    padding-block: ${rem(8)};
    padding-inline: ${rem(12)};
  }
`

interface Props {
  category?: App.MerchandiseCategory
  onClose: () => void
}

function MerchandiseMegaMenuSubcategoryList(props: Props) {
  const { category, onClose } = props

  const [subcategories] = useMerchandiseCategories({
    categoryIds: category?.childCategoryIds || [],
  }, { disabled: !category })

  if (!category) {
    return <Container />
  }

  return <Container>
    <StyledClickableListItem
      to={getMerchandiseCategorySearchUrl(category)}
      onClick={onClose}
      title={`All ${category.name}`}
      titleColour="neutral-one"
      titleWeight="bold"
      size="medium"
    />
    {subcategories.map(subcategory => (
      <StyledClickableListItem
        key={subcategory.id}
        to={getMerchandiseCategorySearchUrl(subcategory)}
        onClick={onClose}
        title={subcategory.name}
        titleColour="neutral-one"
        size="medium"
      />
    ))}
  </Container>
}

export default MerchandiseMegaMenuSubcategoryList
